import { render, staticRenderFns } from "./Dispute.vue?vue&type=template&id=be391aa8&scoped=true&"
import script from "./Dispute.vue?vue&type=script&lang=js&"
export * from "./Dispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be391aa8",
  null
  
)

export default component.exports